import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { BrowseMode, MODES } from '../../models/browse-mode';
import { Store } from '../../../../shared/store';
import { ModeState } from './mode.state';

const modeState: ModeState = new ModeState();
modeState.modes = MODES;
modeState.selectedMode = modeState.modes[0];

@Injectable({ providedIn: 'root' })
export class ModeStore extends Store<ModeState> {
  modes$ = this.state$.pipe(map((s: ModeState) => s.modes));
  selectedMode$ = this.state$.pipe(map((s: ModeState) => s.selectedMode));

  constructor() {
    super(modeState);
  }

  setSelectedMode(nextSelectedMode: BrowseMode): void {
    if (this.state.selectedMode.name === nextSelectedMode.name) {
      return;
    }
    this.setState({ ...this.state, selectedMode: nextSelectedMode });
  }
}
